// extracted by mini-css-extract-plugin
module.exports = {"navTab":"navTab_navTab__BGL9s","navTabMobile":"navTab_navTabMobile__3eXAH"};